function hasSameOrigin(url: string) {
  return new URL(url, window.location.href).origin === window.location.origin;
}

export function setVersionOnEntriesFile({
  url,
  version,
}: {
  url: string;
  version: string;
}) {
  if (!version) {
    return url;
  }

  if (hasSameOrigin(url)) {
    /**
     * The URL is a pathname only and is part of the legacy infrastructure.
     * It looks like this: /assets/exo/some-name/assets-no-cache/remoteEntry.js
     */

    const urlObj = new URL(url, window.location.origin);
    const pathnameParts = urlObj.pathname.split('/');
    return [
      ...pathnameParts.slice(0, 3),
      version,
      ...pathnameParts.slice(3),
    ].join('/');
  }

  const urlObj = new URL(url);

  const pathnameParts = urlObj.pathname.split('/');
  urlObj.pathname = [
    ...pathnameParts.slice(0, 1),
    version,
    ...pathnameParts.slice(1),
  ].join('/');

  return urlObj.toString();
}
